import Blue from "~/core";

new Blue({
	name: 'Footer',
	selector: ".footer",
	setup(footer) {
		const nav = footer.querySelector('.footer__nav');
		const primaryItems = [...nav.querySelectorAll('.nav__primary-item')]

		const toggleAccordionItem = (item, content, method = 'remove') => {
			let start, end;

			start = content.offsetHeight;
			item.classList[method]('is-open');
			end = content.offsetHeight;

			item.querySelector('.nav__primary-label').setAttribute('aria-expanded', item.classList.contains('is-open'));
			content.animate([
				{height: `${start}px`},
				{height: `${end}px`}
			], {
				duration: 250,
				easing: 'ease',
			});
		}

		const bindNavEvents = (item) => {
			const trigger = item.querySelector('.nav__primary-label');
			const content = item.querySelector('.nav__secondary');
			const siblings = primaryItems.filter(s => s !== item);
			trigger.setAttribute('role', 'button');
			trigger.setAttribute('aria-expanded', 'false');
			content.setAttribute('role', 'region');

			this.$addEvents(trigger, 'click.stop.prevent enter.stop.prevent', () => {
				if (this.$screen.lg.matches) return;
				siblings.forEach(s => {
					const content = s.querySelector('.nav__secondary');
					toggleAccordionItem(s, content);
				});
				toggleAccordionItem(item, content, 'toggle');
			})
		};

		primaryItems.forEach(bindNavEvents);
	}
});
